import { render, staticRenderFns } from "./InputWrapper.vue?vue&type=template&id=8a9dce7c&"
import script from "./InputWrapper.vue?vue&type=script&lang=js&"
export * from "./InputWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports